/* eslint-disable radix */
import WebapiCommon from './webapi.common';
import cloneDeep from 'lodash/cloneDeep';
import LaudoApi from '../../../pages/laudo/laudo.api';
import {
  format,
  subDays,
  addDays,
  parseISO,
  formatDistanceStrict
} from 'date-fns';

import pt from 'date-fns/locale/pt';
import { etapasIndexEnum, statusEtapasEnum } from '@common/util/defaultValues';
import { ordemSugeridaEtapas } from '../../../pages/laudo/etapas/etapas.common.util';
import { useIntl } from 'react-intl';


class CommonFunctions {

  static validaData (dataInicio, dataFim, intl) {
    try {
      const tipoAlerta = 'alerta';

      if (dataInicio === undefined || dataInicio === '')
      {
        return {
          valid: false,
          message: `${intl.formatMessage({id: 'dashboards.general.informValidStartDate'})}`
        };
      }

      if (dataFim === undefined || dataFim === '')
      {
        return {
          valid: false,
          message: `${intl.formatMessage({id: 'dashboards.general.informValidEndDate'})}`
        };
      }

      var timeDataInicial = new Date(dataInicio).getTime();
		  var timeDataFinal = new Date(dataFim).getTime();

      if (timeDataInicial > timeDataFinal) {
        return {
          valid: false,
          message: `${intl.formatMessage({id: 'dashboards.general.startDateGreaterEndDate'})}`
        };
      }

      var msDoDia = 1000 * 60 * 60 * 24;
		  var msDiferenca = Math.abs(timeDataFinal - timeDataInicial);
		  var diferencaEmDias = Math.round(msDiferenca / msDoDia);

      if (diferencaEmDias > 366) {
        return {
          valid: false,
          message: `${intl.formatMessage({id: 'dashboards.general.consultationGreater1Year'})}`
        };
      }

      return {
        valid: true,
        message: null
      };
    } catch (error) {
      return {
        valid: false,
        message: `${intl.formatMessage({id: 'dashboards.general.enterValidEndDate'})}`
      };
    }
  }

  static cancelarRecebimentoMaterial = (
    detalhes,
    listagem,
    commonActions,
    justificativa,
    cancelarBlocoAndLaminas
  ) =>
    new Promise(resolve => {
      WebapiCommon.cancelamentoRecebimentoMaterial(
        detalhes.laudo,
        detalhes.nrPedido,
        justificativa,
        cancelarBlocoAndLaminas
        ).then(response => {
          WebapiCommon.obterStatusEtapasLaudo(detalhes.laudo).then(etapas => {

          if (response.data.cancelado) {
            let d = detalhes;
            d.dataEntradaMaterial = '';
            d.nrExame = null;
            commonActions.atualizarDetalhes({...d, etapas});
            if (!listagem && listagem.length === 0)
            {
              commonActions.loadListagem(true);
            }

            // var lista = getListagem(listagem, detalhes.laudo, commonActions);
            let lista = cloneDeep(listagem);

            const listagemIndex = lista.findIndex(
              item => item.laudo === detalhes.laudo
            );

            const item = lista[listagemIndex];
            const etapaIndex = item.etapas.findIndex(
              item => item.etapa === 'MATERIAL'
            );

            let status = detalhes.naoConformidadeMaterial
              ? 'naoconformidade'
              : 'naorealizado';

            lista[listagemIndex].etapas[etapaIndex].status = status;
            lista[listagemIndex].etapas[etapaIndex].dataEtapa = '';
            lista[listagemIndex].nrExame = null;
            lista[listagemIndex].nrExameExterno = null;
            lista[listagemIndex].qtdBloco = null;
            lista[listagemIndex].qtdLamina = null;
            lista[listagemIndex]=detalhes;
            commonActions.preencherListagem(lista);
          }

          resolve(response);
        });
      });
      });

  static fecharExameEtapaRecebimento(props) {
    // props.commonActions.atualizarDetalhes(undefined);
    props.actions.mudarTabAtiva('1');
    props.commonActions.adicionarFrasco([]);
    props.commonActions.adicionarNovoFrasco([]);
    props.commonActions.preencherNaoConformidades([]);
    props.commonActions.preenhcerHistoricoInconformidades([]);
    props.actions.preencherExamesEmAberto([]);
    props.commonActions.preencherExamesConcluidos([]);
    props.history.goBack();
  }

  static atualizarStatusDaEtapaNaListagem (
    laudo,
    etapa,
    listagem,
    novoStatus,
    campos,
    commonActions
  ) {
    let lista = [...listagem];
    const listagemIndex = lista.findIndex(item => item.laudo === laudo);
    const item = lista[listagemIndex];
    const etapaIndex = item.etapas.findIndex(item => item.etapa === etapa);

    lista[listagemIndex].etapas[etapaIndex].status = novoStatus;
    lista[listagemIndex].etapas[etapaIndex].dataEtapa = '';

    if (campos !== null) {
      lista[listagemIndex] = {
        ...lista[listagemIndex],
        ...campos
      };
    }

    commonActions.preencherListagem(lista);
  }

  static onlyNumber (text) {
    return /^\d+$/.test(text);
  }

  static formatData (date) {
    if (date.indexOf(':') >= 0) {
      let nDate = date.split(' ');
      return nDate[0];
    } else {
      return date;
    }
  }

  static cpfMascaraFormatacao (value) {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  }

  static formatoDataValido (text) {
    return /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(
      text
    );
  }

  //data válida com o ano acima de 1000 (0999 abaixo é considerado ano inválido).
  static fomatoDataValidaAcimaAno1000 (text) {
    return /^([1-2][0-9][0-9][0-9])(-)(((0)[0-9])|((1)[0-2]))(-)([0-2][0-9]|(3)[0-1])$/.test(
      text
    );
  }

  static validarDigitoVerificadorCPF = text => {
    let soma;
    let resto;

    soma = 0;

    let conta = 0;
    for (let i = 0; i < text.length; i++) {
      if (text[i] === text[i + 1]) {
        conta++;
      }
    }

    if (conta === 10) {
      return false;
    }

    for (let i = 1; i <= 9; i++) {
      soma = soma + parseInt(text.substring(i - 1, i)) * (11 - i);
    }

    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    if (resto !== parseInt(text.substring(9, 10))) {
      return false;
    }

    soma = 0;

    for (let i = 1; i <= 10; i++) {
      soma = soma + parseInt(text.substring(i - 1, i)) * (12 - i);
    }

    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    if (resto !== parseInt(text.substring(10, 11))) {
      return false;
    }

    return true;
  };

  static getPeriodos () {

    const dataFim = new Date();
    const dataIni = new Date();
    dataIni.setDate(dataFim.getDate() + -7);
    const periodoInicial = `${dataIni.toISOString().slice(0, 10)}`;
    const periodoFinal = `${dataFim.toISOString().slice(0, 10)}`;
    return {
      periodoInicial,
      periodoFinal
    };
  }

  static getPeriodosSubDays (days = 7) {
    return {
      periodoInicial: format(subDays(new Date(), Number(days)), 'yyyy-MM-dd'),
      periodoFinal: format(new Date(), 'yyyy-MM-dd')
    };
  }
  static getPeriodosSubDaysTime (days = 7) {
    return {
      periodoInicial: format(
        subDays(new Date(), Number(days)),
        "yyyy-MM-dd'T'HH:mm"
      ),
      periodoFinal: format(new Date(), "yyyy-MM-dd'T'HH:mm")
    };
  }

  static getPeriodosAddDays (days = 7) {
    return {
      periodoInicial: format(new Date(), 'yyyy-MM-dd'),
      periodoFinal: format(addDays(new Date(), Number(days)), 'yyyy-MM-dd')
    };
  }

  static getPeriodosInterval (daysSub = 7, daysAdd = 7) {
    return {
      periodoInicial: format(
        subDays(new Date(), Number(daysSub)),
        'yyyy-MM-dd'
      ),
      periodoFinal: format(addDays(new Date(), Number(daysAdd)), 'yyyy-MM-dd')
    };
  }

  static formatDate = value =>
    !value ? '' : format(parseISO(value), 'dd/MM/yyyy');

  static formatDateToAge = value =>
    !value
      ? ''
      : formatDistanceStrict(parseISO(value), new Date(), {
          addSuffix: false,
          locale: pt
        });

  static formatDateHour = value =>
    !value ? '' : format(parseISO(value), 'dd/MM/yyyy HH:mm');

  // DD/MM/YYYY HH:mm
  static dateFormat () {
    const dateTimeString = new Date().toLocaleString();
    // Primeiro, dividimos a data completa em duas partes:
    const [date, time] = dateTimeString.split(' ');

    // Dividimos a data em dia, mês e ano:
    const [DD, MM, YYYY] = date.split('/');

    // Dividimos o tempo em hora e minutos:
    const [HH, mm] = time.split(':');

    return `${DD}/${MM}/${YYYY} ${HH}:${mm}`;
  }

  static getProximaEtapaSugerida = etapas => {
    let tab = etapasIndexEnum.MATERIAL;
    for (let s of ordemSugeridaEtapas) {
      let etapa = etapas.find(e => e.etapa === s.etapa);

      if (
        etapa.status === statusEtapasEnum.NAO_CONFORMIDADE &&
        etapa.etapaFinalizada &&
        !etapa.nConfImpeditiva
      ) {
        continue;
      }

      if (
        (etapa.status === statusEtapasEnum.PENDENTE ||
          etapa.status === statusEtapasEnum.REVISAO ||
          etapa.status === statusEtapasEnum.NAO_REALIZADO ||
          etapa.status === statusEtapasEnum.NAO_CONFORMIDADE)
      ) {
        if (
          s.tab === etapasIndexEnum.CONGELACAO ||
          s.tab === etapasIndexEnum.ERRATA ||
          s.tab === etapasIndexEnum.NOTAS
        ) {
          continue;
        } else {
          tab = s.tab;
          break;
        }
      }
    }
    if (tab !== etapasIndexEnum.MATERIAL || tab !== etapasIndexEnum.MACRO) {
      //TODO: remover na proxima versão
      //this.props.actions.showFadeCarregando(false);
    }

    return tab;
  };

  static getPdfBlob = (base64str) => {
    var binary = atob(base64str.replace(/\s/g, ''));
    var len = binary.length;
    var buffer = new ArrayBuffer(len);
    var view = new Uint8Array(buffer);
    for (var i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
    }

    var blob = new Blob( [view], { type: "application/pdf" });
    var url = URL.createObjectURL(blob);
    return url;

  }
}

export default CommonFunctions;



// WEBPACK FOOTER //
// ./src/app/common/util/functions.common.js